import styled, { css } from 'styled-components';
import { DatePicker, AutoComplete } from 'antd';
import { Title } from 'components';

const { RangePicker } = DatePicker;

export const AutoCompleteWrapper = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  position: ${({ position }) => position};
  z-index: ${({ zindex }) => zindex};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'rgba(211, 211, 211, 0.25)'};
  border-radius: 10px;
  backdrop-filter: blur(20px);
  padding: 0 0 0 22px;
  display: flex;
  align-items: center;
  margin-right: 15px;
  i {
    margin-right: 17px;
  }

  @media ${({ theme }) => theme.device.laptop1100} {
    width: ${({ widthLaptop }) => widthLaptop};
    margin: ${({ marginLaptop }) => marginLaptop};
  }
`;

export const DropBtnStyles = styled.div`
  color: ${({ theme }) => theme.colors.text.light};
  i {
    color: ${({ theme }) => theme.colors.text.light};
  }
`;

export const AutoCompleteInput = styled(AutoComplete)`
  &&& {
    width: 368px;
    margin: ${({ margin }) => margin};

    .ant-select-selector {
      background-color: transparent;
      height: 50px;
      padding: 10px 20px;
      font-size: 18px;
      color: white !important;
      input {
        height: 50px;
        padding: 0px 10px;
      }
    }

    /* .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      border: none;
      color: red !important;
    } */

    ${({ border }) =>
      border &&
      css`
        border-radius: 15px;
        border: 1px solid transparent;
      `};
  }
`;

export const SearchBar = styled.div`
  width: ${({ width }) => width};
  /* height: 40px; */
  max-width: 1230px;
  margin: ${({ margin }) => margin || '140px 0'};
  background: transparent;
  box-shadow: ${({ boxShadow }) =>
    boxShadow || '0px 10px 50px rgba(0, 82, 180, 0.1)'};
  border-radius: 10px;

  display: ${({ display }) => display || 'flex'};
  justify-content: space-between;
  align-items: center;

  @media ${({ theme }) => theme.device.laptop1100} {
    width: ${({ width1440 }) => width1440};
    display: ${({ displayLaptop }) => displayLaptop};
    margin: ${({ marginSm }) => marginSm || '40px 0'};
  }

  i {
    color: ${({ theme }) => theme.colors.text.light};
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    color: #333;
  }

  /* @media ${({ theme }) => theme.device.laptop} {
    display: none;
  } */
`;

export const RangePickerTransparent = styled(RangePicker)`
  &&& {
    height: 50px;

    background-color: transparent;
    border: none;
    box-shadow: none;
    margin: ${({ margin }) => margin};
    .ant-picker-active-bar {
      height: 50px;
      padding-left: 25px;
      background: transparent;
    }

    .ant-picker-input > input {
      &::placeholder {
        color: ${({ theme }) => theme.colors.text.white};
        font-family: Rubik;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 140%;
      }
    }

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
      border-color: ${({ theme }) => theme.colors.primary};
    }
    &:focus {
      color: transparent;
    }

    ${({ theme, border }) =>
      border &&
      css`
        border-radius: 15px;
        border: 1px solid ${theme.colors.borders.light};
      `};
  }
`;

export const GuestCounterContainer = styled.div`
  padding: 15px;
`;

export const BtnCounter = styled.div`
  width: ${({ width }) => width || '25px'};
  height: ${({ height }) => height || '25px'};
  font-size: ${({ fontSize }) => fontSize};
  color: #fff;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${({ margin }) => margin || '0 8px'};
  &:hover {
    cursor: pointer;
  }
`;

export const TitleSearchDrop = styled(Title)`
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  line-height: 140%;
  color: ${({ color }) => color};
`;
export const MobileDeviceBreakpoint = styled.div`
  ${({ theme, desktopHidden }) =>
    desktopHidden &&
    css`
      @media ${({ theme }) => theme.deviceMin.tablet} {
        display: none;
      }
    `}

  ${({ theme, desktopHiddenFrom1200 }) =>
    desktopHiddenFrom1200 &&
    css`
      @media (min-width: 1250px) {
        display: none;
      }
    `}

      ${({ theme, tabletHiddenFrom1200 }) =>
    tabletHiddenFrom1200 &&
    css`
      @media (max-width: 1250px) {
        display: none;
      }
    `}

        ${({ theme, tabletGridHidden }) =>
    tabletGridHidden &&
    css`
      @media (min-width: 1100px) {
        display: none;
      }
    `}


  ${({ theme, tabletHidden }) =>
    tabletHidden &&
    css`
      @media (min-width: 768px) {
        display: none;
      }
    `}

    ${({ theme, mobileMGridHidden }) =>
    mobileMGridHidden &&
    css`
      @media (max-width: 1099px) {
        display: none;
      }
    `}

  ${({ theme, mobileMHidden }) =>
    mobileMHidden &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;

export const AirbnbDatePickerContainer = styled.div`
  &&& {
    height: 50px;
    padding: ${({ padding }) => padding};
    margin: ${({ margin }) => margin};
    background: transparent;
    border-radius: 10px;

    .DayPicker__withBorder {
      border-radius: 0px 20px 20px 20px;
    }

    .DayPicker_transitionContainer__horizontal {
      border-radius: 0px 20px 20px 20px;
    }

    .DateRangePicker_picker {
      border: none;
      box-shadow: 0px 10px 50px rgba(0, 82, 180, 0.1);
      border-radius: 0px 20px 20px 20px;
      left: -52px !important;
    }

    .DayPicker_transitionContainer__horizontal {
      border-radius: 0px 20px 20px 20px;
    }

    .DateRangePickerInput__showClearDates {
      padding-right: 5px;
    }

    .DateRangePickerInput {
      display: inline-flex;
      align-items: center;
    }

    .DateRangePicker,
    .DateRangePickerInput,
    .DateInput,
    .DateInput_input {
      text-align: center;
      background-color: transparent;
    }

    .DateInput {
      width: 30%;
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .DateInput_input {
      font-size: 16px;
      font-family: 'Rubik';
      font-weight: 400;
      color: ${({ pickedDateColor }) => pickedDateColor || 'rgb(255 255 255)'};
      overflow: hidden;
      text-overflow: ellipsis;
      height: 50px;
      padding: 12px 0;

      &::placeholder {
        color: #ffffff !important;
      }
    }

    .DateRangePickerInput_arrow {
      &::before {
        content: '—';
        color: #ffffff;
      }
    }

    .DateRangePickerInput_arrow_svg {
      display: none;
    }

    .DateInput_input__focused {
      border-bottom: 2px solid #943fa1;
    }

    .DayPickerKeyboardShortcuts_show__topRight {
      opacity: 0;
    }
    .CalendarDay__default {
      border: none;
      color: #353535;

      &:hover {
        border-radius: 13px;
      }
    }

    .DayPicker__withBorder {
      box-shadow: none;
    }

    .CalendarMonth_table {
      width: 100%;
    }

    .CalendarDay__hovered_span,
    .CalendarDay__hovered_span:hover {
      background-color: #efe2f1;
      border-radius: 0;
    }

    .CalendarMonth_caption {
      text-transform: capitalize;

      strong {
        font-weight: normal;
      }
    }

    .DayPickerKeyboardShortcuts_buttonReset {
      display: none;
    }

    /* .CalendarMonthGrid__vertical,
    .CalendarMonthGrid__vertical_scrollable {
      width: 100% !important;
      font-size: 16px;
    } */

    /* .DayPickerNavigation__verticalScrollableDefault {
      display: none;
    } */

    .CalendarDay {
      font-size: 16px;
      outline: none !important;
    }

    .DayPicker_weekHeader_ul small {
      font-size: 14px;
      color: #9791a7;
      text-transform: capitalize;
    }

    .CalendarDay__selected,
    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
      background: #943fa1;
      border-radius: 13px;
    }

    .CalendarDay__selected {
      position: relative;
      z-index: 10;
      background-color: black;
      color: #ffffff;

      &::before {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: #efe2f1;
        border-radius: 13px 0 0 13px;

        position: absolute;
        right: 0;
        z-index: -1;
        transform: translateY(-50%);
        top: 50%;
      }

      &::after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: #943fa1;
        border-radius: 13px;

        position: absolute;
        right: 0;
        z-index: -1;
        transform: translateY(-50%);
        top: 50%;
      }
    }

    .CalendarDay__selected_start,
    .CalendarDay__selected_start_3,
    .CalendarDay__selected_4,
    .CalendarDay__selected_start_in_hovered_span,
    .CalendarDay__selected_start_in_hovered_span_5 {
      &::before {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: #efe2f1;
        border-radius: 13px 0 0 13px;

        position: absolute;
        right: 0;
        z-index: -1;
        transform: translateY(-50%);
        top: 50%;
      }

      &::after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: #943fa1;
        border-radius: 13px;

        position: absolute;
        right: 0;
        z-index: -1;
        transform: translateY(-50%);
        top: 50%;
      }
    }

    .CalendarDay__selected_end,
    .CalendarDay__selected_end_3 {
      &::before {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: #efe2f1;
        border-radius: 0 13px 13px 0;

        position: absolute;
        right: 0;
        z-index: -1;
        transform: translateY(-50%);
        top: 50%;
      }

      &::after {
        content: '';
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: #943fa1;
        border-radius: 13px;

        position: absolute;
        right: 0;
        z-index: -1;
        transform: translateY(-50%);
        top: 50%;
      }
    }

    .CalendarDay__selected_span {
      color: #353535;
      background: #efe2f1;
      height: 32px;
      color: #353535;
    }

    .DayPicker_weekHeader_ul {
      display: flex;
      justify-content: space-around;
    }

    .CalendarDay__blocked_out_of_range {
      color: #9791a7;
    }

    .DateRangePickerInput_clearDates {
      margin: 0 1px 0 5px;
    }

    .DateRangePickerInput_clearDates svg {
      fill: #000000;
      opacity: 0.3;
    }
  }
`;

export const DatePickerContainer = styled.div`
  &&& {
    height: 50px;
    padding: ${({ padding }) => padding};
    margin: ${({ margin }) => margin};
    background: transparent;
    border-radius: 10px;

    .ant-picker {
      padding: 4px 0;
    }

    .anticon-calendar {
      display: none !important;
    }

    .ant-picker-input > input {
      position: relative;
      display: inline-block;
      width: 100%;
      min-width: 0;
      padding: 4px 0;
      color: ${({ pickedDateColor }) => pickedDateColor || 'rgb(255 255 255)'};
      font-size: 14px;
      line-height: 1.5715;
      background-color: #fff;
      background-image: none;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      -ms-flex: auto;
      flex: auto;
      min-width: 1px;
      height: auto;
      padding: 0;
      background: transparent;
      border: 0;
      cursor: pointer;

      &::placeholder {
        background: placeholderBg;
        color: ${({ theme, placeholderColor, color }) =>
          color ||
          theme.colors.text[placeholderColor] ||
          theme.colors.text.leght};
        opacity: 1; /* Firefox */
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        /* identical to box height */

        color: #798097;
      }
      :-ms-input-placeholder {
        background: placeholderBg;
        /* Internet Explorer 10-11 */
        color: ${({ theme, placeholderColor, color }) =>
          color ||
          theme.colors.text[placeholderColor] ||
          theme.colors.text.leght};
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        /* identical to box height */

        color: #798097;
      }
      ::-ms-input-placeholder {
        background: placeholderBg;
        /* Microsoft Edge */
        color: ${({ theme, placeholderColor, color }) =>
          color ||
          theme.colors.text[placeholderColor] ||
          theme.colors.text.leght};
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        /* identical to box height */

        color: #798097;
      }
    }
  }
`;
